import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Image1 from "../static/Page_1.jpg";
import Image2 from "../static/Page_2.jpg";
import "./AboutUs.css";

export default function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      {/* Hero */}
      <section className="about-hero">
        <div className="about-hero-bg"></div>
        <div className="about-hero-content">
          <span className="hero-label">SINCE 1985</span>
          <h1 className="hero-title">
            OUR <span className="gold-text">STORY</span>
          </h1>
          <p className="hero-description">
            Four decades of bringing Polish masonry excellence to Central New Jersey
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="about-story">
        <div className="about-container">
          <div className="story-grid">
            <div className="story-content">
              <span className="section-label">THE BEGINNING</span>
              <h2 className="story-title">
                A LEGACY OF
                <br />
                <span className="gold-text">CRAFTSMANSHIP</span>
              </h2>
              <div className="story-text">
                <p>
                  In 1985, two Polish immigrants—Paul Banasik and Jack Marchwinski—
                  founded Polonia Construction with a simple vision: bring the 
                  uncompromising standards of Old World masonry to American homes.
                </p>
                <p>
                  Armed with techniques passed down through generations of Polish 
                  craftsmen and an unwavering commitment to quality, they built a 
                  reputation that has stood the test of time. Every brick laid, 
                  every stone placed, every project completed with the same dedication 
                  to excellence.
                </p>
                <p>
                  Today, under the updated name Polania Construction, that legacy 
                  continues stronger than ever.
                </p>
              </div>
            </div>
            <div className="story-image">
              <img src={Image1} alt="Polania heritage" />
              <div className="image-caption">
                Jerzy pictured here in 2000, learning the craft that would 
                become his life's work
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="about-timeline">
        <div className="about-container">
          <div className="timeline-header">
            <span className="section-label">OUR JOURNEY</span>
            <h2 className="section-title">
              40+ YEARS OF <span className="gold-text">EXCELLENCE</span>
            </h2>
          </div>
          <div className="timeline">
            <div className="timeline-item">
              <span className="timeline-year">1985</span>
              <div className="timeline-content">
                <h3>The Beginning</h3>
                <p>Paul Banasik and Jack Marchwinski found Polonia Construction</p>
              </div>
            </div>
            <div className="timeline-item">
              <span className="timeline-year">1990s</span>
              <div className="timeline-content">
                <h3>Growing Reputation</h3>
                <p>Word spreads across Central Jersey about our exceptional work</p>
              </div>
            </div>
            <div className="timeline-item">
              <span className="timeline-year">2000s</span>
              <div className="timeline-content">
                <h3>Expanding Services</h3>
                <p>Adding pavers, retaining walls, and decorative concrete to our expertise</p>
              </div>
            </div>
            <div className="timeline-item">
              <span className="timeline-year">2021</span>
              <div className="timeline-content">
                <h3>New Generation</h3>
                <p>Adrian Wasilewski and Jerzy Murdzek take the helm, continuing the legacy</p>
              </div>
            </div>
            <div className="timeline-item">
              <span className="timeline-year">TODAY</span>
              <div className="timeline-content">
                <h3>Polania Construction</h3>
                <p>Rebranded and stronger than ever, serving Central NJ with pride</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <div className="about-container">
          <div className="team-grid">
            <div className="team-image">
              <img src={Image2} alt="Jerzy ensuring quality" />
            </div>
            <div className="team-content">
              <span className="section-label">LEADERSHIP</span>
              <h2 className="team-title">
                THE NEXT
                <br />
                <span className="gold-text">GENERATION</span>
              </h2>
              <div className="team-text">
                <p>
                  In 2021, the company began its generational transition to new 
                  leadership. Adrian Wasilewski and Jerzy Murdzek—both raised in 
                  the Polish masonry tradition—now guide Polania Construction into 
                  its next chapter.
                </p>
                <p>
                  They bring fresh energy while honoring the values that built this 
                  company: meticulous attention to detail, honest business practices, 
                  and an absolute commitment to customer satisfaction.
                </p>
              </div>
              <div className="team-stats">
                <div className="stat">
                  <span className="stat-number">20+</span>
                  <span className="stat-label">YEARS COMBINED EXPERIENCE</span>
                </div>
                <div className="stat">
                  <span className="stat-number">2,500+</span>
                  <span className="stat-label">PROJECTS COMPLETED</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-values">
        <div className="about-container">
          <div className="values-header">
            <span className="section-label">WHAT DRIVES US</span>
            <h2 className="section-title">
              OUR <span className="gold-text">VALUES</span>
            </h2>
          </div>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <h3>EXCELLENCE</h3>
              <p>We don't cut corners. Every project receives our full attention and highest standards of workmanship.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <h3>INTEGRITY</h3>
              <p>Honest pricing, clear communication, and doing what we say we'll do. Your trust is everything.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <h3>FAMILY</h3>
              <p>We're family-owned and we treat every customer like family. Your satisfaction is our legacy.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="about-container">
          <div className="cta-content">
            <h2>READY TO WORK WITH US?</h2>
            <p>Join the thousands of satisfied homeowners across Central Jersey</p>
            <Link to="/estimate" className="btn-primary">
              GET FREE ESTIMATE
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
